import { useQuery } from "@tanstack/react-query";
import {
	type StraightenerParameterConfig,
	fetchStraightenerParameters,
} from "../repositories/StraightenerParamLimitsRepository";

// Shared by the recipe editor's validation and Configuration > Straightener
// (same query key, so limit edits refresh the editor immediately).
export const STRAIGHTENER_LIMITS_QUERY_KEY = [
	"straightenerParameters",
] as const;

export const useStraightenerParamLimits = () =>
	useQuery<StraightenerParameterConfig[], Error>({
		queryKey: STRAIGHTENER_LIMITS_QUERY_KEY,
		queryFn: fetchStraightenerParameters,
		staleTime: 60 * 1000,
	});
